
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { Box, Container, Divider, Flex, Title } from '@mantine/core';
import RoleBasedComponent from '@/components/common/role/RoleBasedComponent';
import { TenantSelector } from '@/components/common/shared/TenantSelector/TenantSelector';
import Dashboard from '@/components/dashboard/Dashboard';
import { PERMISSIONS } from '@/utils/permissions';
import { useAuth } from '@/services/auth/AuthContext';
import styles from './index.module.css';
const HomePage = () => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
        return null;
    }
    return (<RoleBasedComponent roles={{ resource: { wallet: [PERMISSIONS.VIEW_AGREEMENT] } }}>
    <Container fluid>
      <Flex justify="space-between" align="center">
        <Title order={2} className={styles.title}>
          Dashboard
        </Title>
        <Box className={styles.tenantSelector}>
          <TenantSelector />
        </Box>
      </Flex>
      <Divider className={styles.divider}/>
      <Dashboard />
    </Container>
  </RoleBasedComponent>);
};
export default HomePage;

    async function __Next_Translate__getStaticProps__1a17c5990e7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17c5990e7__ as getStaticProps }
  